<template>
  <div class="hold_invoices_table" id="hold_invoices_table">
    <vs-table
      stripe
      maxHeight="500px"
      :sst="true"
      @search="updateSearchQuery"
      @change-page="handleChangePage"
      @sort="handleSort"
      :total="FilteredCount"
      search
      pagination
      :max-items="this.length"
      :data="holdInvoices"
    >
      <template slot="header">
        <!-- TABLE ACTION ROW -->
        <div class="flex flex-wrap justify-between items-center">
          <!-- ITEMS PER PAGE -->
          <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">
                  {{ page * length - (length - (FilteredCount && 1)) }}
                  -
                  {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                  of {{ FilteredCount }} (filtered from {{ total }} total entries)
                </span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="handleChangeLength(10)">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="handleChangeLength(20)">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="handleChangeLength(50)">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="handleChangeLength(100)">
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </div>
      </template>

      <template slot="thead">
        <vs-th sort-key="hold_sales.id">Sr#</vs-th>
        <vs-th sort-key="hold_sales.hold_code">Hold Code</vs-th>
        <vs-th sort-key="customer.business_name">Client Name</vs-th>
        <vs-th sort-key="hold_sales.hold_date">Hold Date</vs-th>
        <vs-th sort-key="hold_sales.grand_total">Amt</vs-th>
        <vs-th sort-key="user.username">Created By</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{ data }" ref="tableBody">
        <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
          <vs-td>
            {{ i + 1 }}
          </vs-td>
          <vs-td>
            {{ tr.hold_code }}
          </vs-td>
          <vs-td>
            {{ tr.customer.business_name }}
          </vs-td>
          <vs-td>
            {{ formatDate(tr.created_at) }}
          </vs-td>
          <vs-td>
            {{ tr.grand_total | currencyFilter }}
          </vs-td>
          <vs-td>
            {{ tr.user.username }}
          </vs-td>
          <vs-td>
            <div class="inline-flex">
              <vx-tooltip text="Edit Invoice">
                <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editHoldInvoice(tr.id)" />
              </vx-tooltip>
              <vx-tooltip text="Delete Invoice">
                <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 mr-4 hover:text-danger cursor-pointer" @click="confirmDeleteInvoice(tr.id)" />
              </vx-tooltip>
              <vx-tooltip text="PDF Hold Invoice">
                <feather-icon icon="FileTextIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="setPdfHoldInvoice(tr)" />
              </vx-tooltip>
              <vx-tooltip text="Download Manifest">
                <feather-icon icon="ShoppingCartIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="setHoldMenifest(tr)" />
              </vx-tooltip>
              <vx-tooltip text="Download PDF Manifest">
                <feather-icon icon="FileTextIcon" svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="setPDFHoldMenifest(tr)" />
              </vx-tooltip>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div v-show="false">
      <pdf-hold-invoice ref="pdf-hold-invoice" :saleId.sync="saleId" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { dateMixins } from '@/mixins/dateMixins.js'
import PdfHoldInvoice from '@/views/pos/pdf/PdfHoldInvoice.vue'
import { paymentMixins } from '@/utils/paymentTypes'
import axios from '@/axios'

export default {
  name: 'HoldInvoicesTable',
  data: () => ({
    //hold sales id
    saleId: null,
    order: [],
    length: 10,
    page: 1,
    search: '',
    quantity: 0,
    id: 0,
    loading: false
  }),

  mixins: [paymentMixins, dateMixins],

  props: {
    get_hold_invoices: Boolean
  },
  computed: {
    ...mapState('pos', ['holdInvoices', 'total', 'FilteredCount'])
  },

  methods: {
    ...mapActions('pos', { fetchHoldInvoices: 'get_all_hold_invoices', removeHoldInvoiceById: 'delete_hold_invoice_by_id', fetch_hold_invoice_by_id: 'get_hold_invoice_by_id' }),

    // fetch all hold invoices``
    async fetch_hold_invoices() {
      try {
        const { order, length, page, search } = this

        await this.fetchHoldInvoices({
          order,
          limit: length,
          page,
          search
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    // search record
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.fetch_hold_invoices()
    },

    // handle change page
    handleChangePage(page) {
      this.page = page
      this.fetch_hold_invoices()
    },

    // sort the data in table
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.fetch_hold_invoices()
    },

    // handle change limit - records per page
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.fetch_hold_invoices()
    },
    async setPdfHoldInvoice(tr) {
      this.loading = true
      axios
        .get(`hold-sales/hold-pdf/${tr.id}`, { responseType: 'blob' })
        .then((response) => {
          const blob = new Blob([response.data], { type: 'application/pdf' })
          const link = document.createElement('a')
          link.style.width = '100% !important'
          link.href = URL.createObjectURL(blob)
          link.download = 'hold-invoice.pdf'
          link.click()
          URL.revokeObjectURL(link.href)
          this.loading = false
        })
        .catch(console.error)
    },
    // edit hold invoice
    async editHoldInvoice(id) {
      this.$emit('close_hold_invoices_table', !this.get_hold_invoices)

      this.$router
        .push({
          name: 'update_hold_invoice',
          params: {
            id
          }
        })
        .catch(() => {})
    },

    confirmDeleteInvoice(holdInvoiceId) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure, you want to delete this record?',
        accept: () => this.deleteHoldInvoice(holdInvoiceId),
        acceptText: 'Delete'
      })
    },

    // delete hold invoice
    async deleteHoldInvoice(holdInvoiceId) {
      try {
        const { message } = await this.removeHoldInvoiceById(holdInvoiceId)

        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })

        this.$root.$emit('toggle_hold_invoices', false)
        this.$router.go()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    async setPDFHoldMenifest(tr) {
      this.saleId = tr.id
      const {
        data: { holdSales }
      } = await this.fetch_hold_invoice_by_id(tr.id)
      try {
        this.generating = true
        const { data } = await axios({
          url: process.env.VUE_APP_PDF_HOLD_MENIFEST_URI,
          method: 'POST',
          responseType: 'blob',
          data: JSON.stringify(holdSales)
        })
        const url = window.URL.createObjectURL(data)
        const a = document.createElement('a')
        a.href = url
        a.download = 'hold_manifest_not_editable.pdf'
        a.click()
        a.remove()
        setTimeout(() => window.URL.revokeObjectURL(url), 100)
        this.generating = false
      } catch (err) {
        this.generating = false
      }
    },

    // download hold menifest
    async setHoldMenifest(tr) {
      this.saleId = tr.id
      const {
        data: { holdSales }
      } = await this.fetch_hold_invoice_by_id(tr.id)
      try {
        this.generating = true
        const { data } = await axios({
          url: process.env.VUE_APP_HOLD_MENIFEST_URI,
          method: 'POST',
          responseType: 'blob',
          data: JSON.stringify(holdSales)
        })
        const url = window.URL.createObjectURL(data)
        const a = document.createElement('a')
        a.href = url
        a.download = 'shipping_manifest.pdf'
        a.click()
        a.remove()
        setTimeout(() => window.URL.revokeObjectURL(url), 100)
        this.generating = false
      } catch (err) {
        this.generating = false
      }
    }
  },

  // filters
  filters: {
    // currencyFilter rounded to 2 point
    currencyFilter(value) {
      return paymentMixins.methods.mathRound(Number(value), 2)
    }
  },

  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#hold_invoices_table',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#hold_invoices_table > .con-vs-loading')
      }
    },

    async get_hold_invoices() {
      if (this.get_hold_invoices) {
        await this.fetch_hold_invoices()
      }
    }
  },
  components: {
    PdfHoldInvoice
  }
}
</script>

<style lang="scss">
.con-vs-dropdown--menu {
  z-index: 55000;
}

.con-vs-dialog {
  z-index: 530000;
}
</style>